.star { width: 44px; height: 44px; flex: none; display: inline-flex; align-items: center; justify-content: center;
  color: var(--content-secondary); border-radius: 50%; }
.star:disabled { opacity: 0.5; }
.on { color: var(--accent); }
